<template>
	<div>
		<el-card class="table-card" shadow="always">
			<div slot="header" class="clearfix">
				<span>资产信息</span>
			</div>
			<div class="base-info">
				<div class="info-desc">
					<el-descriptions class="margin-top" :column="2" border>
						<el-descriptions-item label="资产编号">{{ data.assetNo }}</el-descriptions-item>
						<el-descriptions-item label="资产名称">{{ data.assetName }}</el-descriptions-item>
						<el-descriptions-item label="资产分类">
							{{ $menu.getLabel('AssetCategory', data.assetCategory) }}
						</el-descriptions-item>
						<el-descriptions-item label="所属项目">{{ data.communityName }}</el-descriptions-item>
						<el-descriptions-item label="位置信息" :span="2">{{ data.location }}</el-descriptions-item>
						<el-descriptions-item label="建筑面积">{{ data.buildingArea }}</el-descriptions-item>
						<el-descriptions-item label="使用面积">{{ data.useArea }}</el-descriptions-item>
						<el-descriptions-item label="资产原值">{{ data.originalValue }}</el-descriptions-item>
						<el-descriptions-item label="土地价值">{{ data.landValue }}</el-descriptions-item>
						<el-descriptions-item label="产权归属">{{ data.propertyRight }}</el-descriptions-item>
						<el-descriptions-item label="资产状态">
							<el-tag :type="AssetStatus[data.status] || 'default'" size="small">
								{{ $menu.getLabel('AssetStatus', data.status) || '-' }}
							</el-tag>
						</el-descriptions-item>
						<el-descriptions-item label="规划类型">{{ data.planningType }}</el-descriptions-item>
						<el-descriptions-item label="建档日期	">{{ data.recordDate }}</el-descriptions-item>
					</el-descriptions>
				</div>
				<div class="info-qrcode" @click="showQrcode">
					<img :src="data.qrCode" alt="二维码" class="qrcode" />
					<div>点击查看二维码</div>
					<el-button type="text" icon="el-icon-view" size="small">查看</el-button>
				</div>
			</div>
			<div class="remark">
				<div>备注：</div>
				<div class="remark-info">{{ data.remark }}</div>
			</div>
		</el-card>
		<el-card class="table-card" shadow="always">
			<div slot="header" class="clearfix">
				<span>折旧信息</span>
			</div>
			<div>
				<div class="depreciation-list">
					<div class="depreciation-item">
						<div>预计使用年限</div>
						<div>{{ data.serviceLife || '--' }}年</div>
					</div>
					<div class="depreciation-item">
						<div>预计净残值率</div>
						<div>{{ data.residualValue || '--' }}%</div>
					</div>
					<div class="depreciation-item">
						<div>月折旧额</div>
						<div>{{ data.monthlyDepreciation || '--' }}元</div>
					</div>
					<div class="depreciation-item">
						<div>年折旧额</div>
						<div>{{ data.annualDepreciation }}元</div>
					</div>
				</div>
				<el-divider></el-divider>
				<div class="depreciation-list">
					<div class="depreciation-item">
						<div>累计折旧</div>
						<div style="color: #1890ff">{{ data.accumulatedDepreciation || '--' }}元</div>
					</div>
					<div class="depreciation-item">
						<div>资产净值</div>
						<div style="color: #52c41a">{{ data.netValue || '--' }}元</div>
					</div>
					<div class="depreciation-item">
						<div>折旧方法</div>
						<div>{{ data.depreciationMethod || '--' }}</div>
					</div>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
	import { AssetStatus } from '@/utils/meunType.js';
	export default {
		name: 'AssetLedgerBaseInfo',
		props: {
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				AssetStatus,
			};
		},
		methods: {
			showQrcode() {
				this.$emit('showQrcode');
			},
		},
	};
</script>

<style scoped lang="scss">
	.table-card {
		margin-bottom: 15px;
	}
	.base-info {
		display: flex;
		gap: 30px;
		.info-desc {
			flex: 1;
		}
		.info-qrcode {
			width: 150px;
			display: flex;
			flex-direction: column;
			align-items: center;
			color: #999;
			font-size: 12px;
			cursor: pointer;
			.qrcode {
				margin-bottom: 12px;
				width: 100%;
				height: 150px;
			}
		}
	}

	.remark {
		margin-top: 10px;
		color: #1c1c1c;
		font-size: 14px;
		font-weight: 500;
		&-info {
			margin-top: 8px;
			box-sizing: border-box;
			background-color: #ebebeb;
			width: 100%;
			padding: 10px 12px;
			color: #333;
			border-radius: 5px;
		}
	}

	.depreciation-list {
		display: flex;
		justify-content: space-between;
		align-items: center;
		.depreciation-item {
			display: flex;
			flex-direction: column;
			gap: 6px;
			font-size: 20px;
			color: #1c1c1c;
		}
		.depreciation-item :first-child {
			font-size: 14px;
			color: #666;
		}
	}
</style>
